module.exports = __webpack_public_path__ + "img/195.d8ba409e.png";